import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function MemberPage() {
  return (
    <main
      data-testid="member-page"
      className="min-h-screen bg-[#0a0a09] flex flex-col items-center justify-center px-6 text-center relative"
    >
      <Seo title="W8ED — Members" description="You waited. It counted." path="/member" />
      <img
        src="/w8ed-emblem.png"
        alt="W8ED — golden eight over the mountain"
        className="w-48 sm:w-64"
      />
      <h1 className="mt-10 font-display text-2xl font-extrabold tracking-tight text-[#f5f2ea] sm:text-3xl">
        You waited. It counted.
      </h1>
      <p
        data-testid="member-tagline"
        className="mt-6 font-mono text-[11px] tracking-[0.2em] uppercase text-[#8e8a80] leading-relaxed"
      >
        The door is open. Walk through it quietly.
        <br />
        <br />
        Nothing changes on the outside.
        <br />
        Everything changes on the inside.
      </p>
      <p className="mt-8 font-mono text-[10px] tracking-[0.35em] uppercase text-[#C9A227]">
        Discipline &gt; Dopamine
      </p>
      <Link
        to="/"
        data-testid="member-back-link"
        className="absolute bottom-8 font-mono text-[10px] tracking-[0.3em] uppercase text-[#57534a] hover:text-[#C9A227] transition-colors"
      >
        W8ED
      </Link>
    </main>
  );
}
